import { createSlice } from '@reduxjs/toolkit'

export const kybListSlice = createSlice({
  name: 'kybList',
  initialState: {
    list: {},
    selectedItems: [],
    filters: {
      page: 0,
      limit: 25,
      offset: 0,
      fromDate: null,
      toDate: '',
      id: '',
      status: null,
      name: '',
      documentNumber: '',
    },
  },
  reducers: {
    updateKybList: (state, action) => {
      state.list = action.payload
    },
    updateKybListFilters: (state, action) => {
      state.filters = action.payload
    },
    deleteSelectedItems: (state, action) => {
      state.selectedItems = action.payload
    },
  },
})

export const { updateKybList, updateKybListFilters, deleteSelectedItems } = kybListSlice.actions
export default kybListSlice.reducer
